module.exports = __webpack_public_path__ + "media/site_templates/www.localhomebuilders.net.au/images/feature_3-95c810efe01e53c3ce927f0114ea29b0.jpeg";